<div class="d-flex align-items-center">
    Su pais es:
    <ng-select class="ps-1 flex-grow-1" [items]="$any(paises | async)" bindValue="codigo" bindLabel="nombre"
        [(ngModel)]="condicion.data">
        <ng-template ng-option-tmp let-item="item">
            {{item.nombre}}
        </ng-template>
    </ng-select>
    <div class="flex-grow-0 text-end my-auto" [class.seleccionable]="borrarOperandoCmd.puedeEjecutarse"
        [command]="borrarOperandoCmd">
        <span><i class="fa-regular fa-trash-can fa-xl"></i></span>
    </div>
</div>
